
// import state_auth from '@/stores/auth/state'  // for 'error' function

import { pp, link } from '@helpers'
import { authStore } from '@stores'



export {
    myConfirmDialog,
    flash,
    notify,
    e, // ERROR msg
}

/**
 * @param Function  action   ex:  ()=>function()
 * @param String    msg
 * @param String    ok_label
 * @param String    color
 */
const myConfirmDialog = (action, msg = '', ok_label = 'Enregistrer', color = 'positive') =>{

    $q.dialog({
        title: 'Confirmation...', message: msg, square: true, html: true, persistent: true,
        cancel: true, ok: {label: ok_label, noCaps: true, square: true, color: color}
    })
    .onOk(()=>{ action() })
}


const flash = (datas)=>{

    var v = _.size(datas.flash) ? datas.flash : null//datas.jetstream?.flash

// log('in helpers/notify FLASH ', v, datas)

    // if(_.size(v)){
    if(v){

        notify(
            v.type,
            v.msg,
            v.caption,
            v.timeout,
            true, false, 'top'
        )

        pp().flash = {}//[]
        // pp().jetstream.flash = []
    }
}

/**
 * Notification
 *
 * @param {String} type (positive|info|negative|warning)
 * @param {String} msg  (text or html)
 */
const notify = (type, msg = '', caption = '', timeout = 5000, closeBtn = true, sound = false, position = 'bottom', id_dismiss = 0)=>{
// export function notify (type, msg = '', caption = '', timeout = 5000, closeBtn = true, sound = false, position = 'bottom', id_dismiss = 0){
    // app.notify = (type, msg = '', caption = '', timeout = 5000, closeBtn = true, sound = false, position = 'bottom', id_dismiss = 0)=>{

        var icon = 'done'; // default if positive message
        var color = 'green-8';
        var textColor = 'white';
        if(type == 'info'){
            icon = 'info';
            color = 'info';
        } else if(type == 'negative'){
            icon = 'error_outline';
            color = 'red-8';
        } else if(type == 'warning'){
            icon = 'warning';
            color = 'orange-8';
        }

        // if(proto.user && proto.user.sound && sound){
        //     if(type == 'positive' || type == 'info'){
        //         this.playSound('notify-sound-success');
        //     } else {
        //         this.playSound('notify-sound-warning');
        //     }
        // }
// const proto = pp()

//         proto.$_dismissNotify[id_dismiss] = // for dismiss an permanent notify (if timeout == 0)


            $q.notify({
                message: msg,
                multiLine: (msg.length > 200 ? true : false),
                progress: true,
                // dense: true, padding: 'xs',
                html: true,
                square: true,
                classes: 'notify-class square',// glossy',
                timeout: timeout, // in milliseconds; 0 means no timeout
                color: color,
                type: type,// Available values: 'positive', 'negative', 'warning', 'info', 'ongoing'
    //			color: type,// Available values: 'positive', 'negative', 'warning', 'info'
        		textColor: textColor, // if default 'white' doesn't fits
                icon: icon,
                caption: caption,//optionalDetails,
                position: position, // top-left top-right bottom-left bottom-right top bottom left right center
                actions: closeBtn ? [ { icon: 'close', handler: (Function), dense: true, color: 'white', noDismiss: false }] : [],
        //		,actions: closeBtn ? [ {  label: '',  icon: 'close' } ] : []
                // actions: closeBtn
                // 			? (!timeout && (_.includes(_.toLower(msg), 'cible') && _.includes(_.toLower(msg), 'copié')/*tout ça car ça peut être au pluriel*/)
                // 					? [{
                // 						label: '',
                // 						icon: 'cancel', color: 'white', // optional
                // 						noDismiss: true,
                // 						handler: () => { Vue.store.commit(''); }
                // 					  }]
                // 					: [ { icon: 'close', color: 'white' } ])
                // 			: []
            });

        if(process.env.NODE_ENV !== 'production'){
            console.info('Notify '+type+' : ', msg, caption);
        }

}


/**
 * Manage messages error
 * @param {String} method
 * @param {Object|String} error
 */
const e = (method, error)=>{

    var title = 'Bug in '+method+' : '


	if(error?.error_obj?.message?.match(/301|302|401|403|404|500|502|503|504/g)){
		return false
	}



    var route_login = route('login-view')

    // if(_.endsWith(error, '401')){
    if(_.includes(error?.error_obj?.message, 401)){
        authStore().msgError401Already = true; // pour ne pas l'afficher 2 fois (voir Login.vue)
        notify('info',"Vous avez été déconnecté(e).",'',0)
        return link(route_login)
    }
    // if(_.endsWith(error, '419')){
    if(_.includes(error?.error_obj?.message, 419)){
        notify('info',"Page Expirée. Veuillez recharger la page.",'',0)
        return link(route_login)
    }



    function sendErrorJs(error){

        //! //////////////////////////////////////
        if( ! isProd){ return false } //! /!\ A ACTIVER
        //! //////////////////////////////////////

        error.stack = _.toString(error.error_obj?.stack)
        // delete(error.error_obj)
        // console.log(error)

        axios.post(route('send-error-js'), {
                    title: title,
                    err: error,
                    page: route().current(),
                })
                .then((res)=>{
                    if(res.data?.mail_sended){          notify('info', 'Erreur automatiquement transmise...','Nous allons faire le nécessaire pour la corriger.', 0) }
                    if(res.data?.error_already_sended){ notify('info', 'Cette erreur nous a déjà été transmise...','Nous faisons le nécessaire pour la corriger.', 5000) }
                    if(res.data?.cache_key){            log(`Error CACHE KEY used : ${res.data.cache_key}`) }
                })
                // .catch(()=>{ fn.notify('warning', 'Impossible d\'envoyer l\'erreur !') })
    }


    // si ça vient de resources/js/app.js  @onErrorCaptured()
    if(_.isObject(error)){

        // si ce n'est pas un souci de connexion internet..
        if(! error.error_obj?.stack?.match(/ERR_NETWORK/g)/*  || ! error.infos?.match(/ERR_NETWORK/g) */){
            sendErrorJs(error)
        }
        // error = `COMPONENT: ${error?.component}<br/>baseURI: ${error?.uri}<br/>ERROR: ${error?.error_obj?.message}`//<br/>INFOS: ${error?.infos}
        error = `${error?.component} - ${error?.uri}<br/>${error?.error_obj?.message}`
    }



    /* function dialogWithWebmaster(...vars){

        $q.dialog({html:true, class:'bg-warning', title:'Ajoutez peut-être un message descriptif...', message: "(?) Sur quelle action, à quel moment, etc...<br/>Mais restez bref et concis s'il vous plaît.<br/>Merci.",
            prompt: {
                model: '', label: 'Votre message sur: '+vars[0],
                type: 'textarea' // optional
            },
            cancel:'Annuler', ok:'Envoyer', persistent: true
        }).onOk((msg)=>{

            axios.post('/send-error-to-webmaster', { title:vars[0], error: vars[1], page: route().current(), message: msg, moment: fn.formatDate('', true) })
                .then(()=>{ notify('info', 'Ok. Je pourrai dans certains cas vous répondre par e-mail..', "N'en abusez pas s'il vous plait, car l'erreur a peut-être déjà été soulevée par quelqu'un d'autre...", 10000) })
                .catch(()=>{ notify('warning', "Impossible d'envoyer l'erreur !") })
        });

    }

    var actions = isProd ? [
    // var actions = [
        { label: 'Envoyez l\'Erreur au Développeur', handler:()=>{ dialogWithWebmaster('Error in '+method, error) }, color: 'white', textColor: 'red-8', outline: true },
    ]
    : []; */
    var actions = []

    if( ! pp().$_hasTouch && ! isProd){
        actions.push({ label: 'Fermer et Vider la console', handler:()=>{ console.clear(); }, color: 'white', textColor: 'grey-8', outline: true });
    }

    $q.notify({
        message: `<b>Oooops, pardon pour le désagrément.<br/>${title}</b>`,

        caption: `<div style="word-break: break-word!important;line-height: 13px!important">
                    <span class="text-grey-8">${error}</span><br/>
                    <p class="bg-grey-2 text-grey-8 q-pa-xs q-ma-none" style="line-height: 10px!important">
                        <small>Si cette erreur est survenue après une action de votre part,<br/><b>inutile de relancer cette même action</b>.<br/>Tentez de recharger la page pour voir si l'action s'est tout de même déroulée.<br/>Merci de votre compréhension.</small>
                    </p>
                </div>`,
                //, l'erreur reviendra forcément et vous risquez de "polluer" la Base de Données avec des données tronquées ou incomplètes...
        multiLine: true, dense: true, html: true, type: 'warning', timeout: 0,
        position: 'top-right', square: true,
        textColor: 'grey-2', group: 'error_'+_.deburr(method),
        color: 'amber-6',
        badgePosition:'bottom-right', //, icon: 'warning' badgeColor: 'red-8',
        classes: 'notify-class',
        // attrs:{style: 'word-break: break-word!important;width:100%!important'},
        closeBtn: true,
        actions: actions
    });

    console.error(title, error);
}
